import {
  SET_STUDENT_PAYMENT_DATA,
  SET_STUDENT_RECEIPTS_DATA,
  SHOW_STUDENT_PAYMENT_DIALOG,
  SET_STUDENT_MISC_PAYMENT_DATA,
  SET_TEACHER_SALARY_DATA,
  SET_TEACHER_SALARY_DETAIL,
  SHOW_TEACHER_PAYMENT_DIALOG,
  SET_PAYMENT_HISTORY_DATA,
  SET_FINANCE_REPORT_STUDENTS_DATA,
  SET_FINANCE_REPORT_MONTHLY_DATA
} from "../types";

export const paymentStates = {
  studentPayment: [],
  studentPaymentDetail: [],
  teachersSalary: [],
  teacherSalaryDetail: [],
  miscStudentPayment: [],
  miscStudentPaymentDetail: [],
  paymentHistory: [],
  studentsFinanceReport: [],
  monhtlyFinanceReport: {},
  studentDetailDialogVisible: false,
  teacherPaymentDetailDialogVisible: false,
};

export const paymentReducer = (state, action) => {
  switch (action.type) {
    case SET_STUDENT_PAYMENT_DATA:
      return {
        ...state,
        ...action.data
      };
    case SET_STUDENT_RECEIPTS_DATA:
      return {
        ...state,
        ...action.data
      };
    case SET_STUDENT_MISC_PAYMENT_DATA:
      return {
        ...state,
        ...action.data
      };
    case SHOW_STUDENT_PAYMENT_DIALOG:
      return {
        ...state,
        studentDetailDialogVisible: action.data,
      };
    case SET_TEACHER_SALARY_DATA:
      return {
        ...state,
        teachersSalary: action.data
      };
    case SET_TEACHER_SALARY_DETAIL:
      return {
        ...state,
        teacherSalaryDetail: action.data
      };
    case SHOW_TEACHER_PAYMENT_DIALOG:
      return {
        ...state,
        teacherPaymentDetailDialogVisible: action.data,
      };
    case SET_PAYMENT_HISTORY_DATA:
      return {
        ...state,
        paymentHistory: action.data
      };

    case SET_FINANCE_REPORT_STUDENTS_DATA:
      return {
        ...state,
        studentsFinanceReport: action.data
      };

    case SET_FINANCE_REPORT_MONTHLY_DATA:
      return {
        ...state,
        monhtlyFinanceReport: action.data
      };
    default: return state
  }
};